import {mapGetters, mapMutations} from "vuex";

export default {
    name: 'ChatMixin',
    data: () => ({
        loading: false,
        conversationId: null,
        dialogs: [],
        messages: [],
    }),
    watch: {
        conversationId() {
            this.getConversationMessages();
        }
    },
    computed: {
        ...mapGetters(['getRole', 'getUser', 'getEchoClient'])
    },
    methods: {
        ...mapMutations(['setUser', 'setMessage']),
        read() {
            this.$api.auth.update({'new_message': 0}).then(({data}) => {
                setTimeout(() => this.setUser(data), 3000);
            });
        },
        loadDialogues() {
            this.getConversations().then(({data}) => {
                this.dialogs = data;
                this.dialogs.forEach((dialog) => {
                    this.getEchoClient.private(`mc-chat-conversation.${dialog.conversation_id}`).listen('\\Musonza\\Chat\\Eventing\\MessageWasSent', (e) => {
                        if (e.message.sender.id !== this.getUser.id) {
                            if (dialog.conversation_id === this.conversationId) {
                                this.messages.push(e.message);
                            }
                            this.updateLastMessage(e.message);
                            this.setMessage(true);
                        }
                    });
                })
            });
        },
        setConversationId(id) {
            this.conversationId = id;
        },
        getConversationMessages() {
            this.loading = true;
            this.$api.chat.messages({id: this.conversationId})
                .then(({data}) => {
                    this.messages = data;
                })
                .finally(() => this.loading = false)
        },
        createConversation(recipient_id) {
            this.$api.chat.create({id: recipient_id}).then(() => {
                this.$router.push('/cabinet/' + this.getRole + '/messages');
            });
        },
        getConversations() {
            return this.$api.chat.all();
        },
        addConversationMessage(message) {
            if (!message) return this.$toast.error('Укажите текст сообщения!');
            if (this.conversationId) {
                this.$api.chat.add({id: this.conversationId, message: message}).then((response) => {
                    this.updateLastMessage(response);
                    this.messages.push(response);
                })
            }
        },
        updateLastMessage(message) {
            this.setMessage(false);
            let index = this.dialogs.findIndex((item) => {
                return item.conversation.id === message.conversation_id;
            });
            if (index !== -1) {
                this.dialogs[index].conversation.last_message = message;
            }
        }
    }
}
